import { render, staticRenderFns } from "./AutomatorButton.vue?vue&type=template&id=a1d47f14&scoped=true&"
import script from "./AutomatorButton.vue?vue&type=script&lang=js&"
export * from "./AutomatorButton.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorButton.vue?vue&type=style&index=0&id=a1d47f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d47f14",
  null
  
)

export default component.exports